// src/components/GeneralServices.js
import React from 'react';
import './Generalservise.css';

import ServiceImage from '../../../imgs/productsp.webp';

const Productspecial = () => {
    const services = [
        {
            title: 'PRODUCT SPECIALIZED SERIES',
            description: ' Special For Products Lower Cost'
        },
  
    ];

    return (
        <div className="container-p">
            <h2 className="services-title"> </h2>
            <div className="services-grid-1" data-aos="flip-right">
                {services.map((service, index) => (
                    <div className="gen-service-card" key={index}>
                         <div className="service-content-1">
                            <h3 className="service-heading-1">{service.title}</h3>
                            <p className="service-description-1">{service.description}</p>
                        </div>
                        <div>
                            <img src={ServiceImage} alt="Service" className="service-image" />

                        </div>
                       
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Productspecial;
